import React, { useState } from 'react';
import { BASE_URL } from '../../constant/api';

const ProductImagesGrid = ({ productImages }) => {
    const [selectedImage, setSelectedImage] = useState(null); // State for the main image

    const getImageUrl = (image) => {
        if (!image) return "/images/default-product.png";
        return image.includes(BASE_URL) ? image : `${BASE_URL}${image}`;
    };

    // Set the first image as the default selected image
    React.useEffect(() => {
        if (productImages?.length) {
            setSelectedImage(productImages[0].image); // Default to the first image
        }
    }, [productImages]);

    return (
        <div className="lg:w-full flex flex-col md:flex-row gap-2 items-center lg:items-start">
            <div className="w-full mb-4">
                {/* Main Product Image */}
                <img
                    src={getImageUrl(selectedImage)}
                    alt="Product"
                    className="object-contain w-full h-80 max-w-full rounded-lg"
                />
            </div>

            <div className="flex flex-row md:flex-col gap-2 w-screen px-2 md:w-1/3 h-fit md:h-[356px] overflow-x-auto md:overflow-x-hidden overflow-y-hidden md:overflow-y-auto">
                {/* Thumbnails */}
                {productImages?.map((img, idx) => (
                    <div key={idx} className="h-20 w-20 flex-shrink-0">
                        <img
                            src={getImageUrl(img.image)}
                            alt="Thumbnail"
                            className={`w-full h-full object-contain rounded-lg cursor-pointer transition ease-in-out duration-300 
                ${getImageUrl(img.image) === getImageUrl(selectedImage) ? "border-2 border-brand-primary" : "border"}`}
                            onClick={() => setSelectedImage(img.image)} // Set the clicked image as the main image
                        />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ProductImagesGrid;
